import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { Loader, X } from "lucide-react";
import { useEffect, useState } from "react";
import moment from "moment";
import { ShimmerDialogEditProduct } from "components/app/shrimmer/Shrimmer";
import appStore from "store/appStore";
import { useDispatch } from "react-redux";
import { setOpenPopoverIndex } from "store/request";
import DailogAddRemark from "pages/business-suite/dialog/dialogEmployeeLeaveRequest/DailogAddRemark";
import DailogAddApprovers from "pages/business-suite/dialog/dialogEmployeeLeaveRequest/DailogAddApprovers";
import DailogAddWorkflow from "pages/business-suite/dialog/dialogEmployeeLeaveRequest/DailogAddWorkflow";
import Requester from "./Requester";
import RequestleaveApplicationForm from "./RequestleaveApplicationForm";
import Status from "pages/business-suite/Status";
import TardinessApplicationForm from "./TardinessApplicationForm";
import ChangeDOApplicationForm from "./ChangeDOApplicationForm";
import ChangeShiftApplicationForm from "./ChangeShiftApplicationForm";
import AddApproverRequest from "./AddApproverRequest";
import { DocumentStatus } from "utils/enum/documentStatus";
import useRequestAction from "../useRequestAction";
export default function PageLeavRequest({
  employeeInitRequest,
  loadingSubmitEmployeeInitRequest,
  handleSaveLeaveApplicationFrom,
  handleSaveTardinessApplicationFrom,
  handleSaveChangeDOApplicationFrom,
  handleSaveChangeShifApplicationFrom,
  setEmployeeInitRequest,
  loadingEmployeeInitRequestSearchDatail,
  loadingEmployeeInitRequest,
  getShopEmployeeRequestCommittee,
  shopEmployeeRequestCommittee,
  handleAddApprover,
  handleScrollCommittee,
  scrollContainerRef,
  warning,
  errorStatus,
  fetchMoreDataCommittee,
  setShopEmployeeRequestCommittee,
  isAddApproverLoading,
  submitShopEmployeeRequestUpdateStatus,
  submitShopEmployeeRequestUpdateStatusLoading,
  warning2,
  leaveApplicationFrom,
  setLeaveApplicationFrom,
  tardinessApplicationFrom,
  setTardinessApplicationFrom,
  changeDoApplicationFrom,
  setChangeDoApplicationFrom,
  changeShiftApplication,
  setChangeShiftApplication,
}: any) {
  // *================Globle Store State===========
  const dispatch = useDispatch();
  const { showDialogConfirm } = appStore();

  // *================Function===========
  const handleChangeLeaveRequest = (field: string, value: any) => {
    setLeaveApplicationFrom((prev: any) => ({
      ...prev,
      [field]: value,
    }));
  };
  const handleChangeTardinessRequest = (field: string, value: any) => {
    setTardinessApplicationFrom((prev: any) => ({
      ...prev,
      [field]: value,
    }));
  };
  const handleChangeDoRequest = (field: string, value: any) => {
    setChangeDoApplicationFrom((prev: any) => ({
      ...prev,
      [field]: value,
    }));
  };
  const handleChangeShiftRequest = (field: string, value: any) => {
    setChangeShiftApplication((prev: any) => ({
      ...prev,
      [field]: value,
    }));
  };
  const handleClick = (code: string) => {
    const parts = selectedCodes ? selectedCodes.split("|").map((s) => s.trim()) : [];
    const updatedParts = parts.includes(code) ? parts.filter((item) => item !== code) : [...parts, code];
    const updatedString = updatedParts.join("|");
    setSelectedCodes(updatedString);
    setTardinessApplicationFrom((prevData: any) => ({
      ...prevData,
      missing_period: updatedString,
    }));
  };
  const handleCloseDetail = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete("request_id");
    window.history.pushState({}, "", url.toString());
    dispatch(setOpenPopoverIndex(null));
  };
  const renderButtonSubmit = () => {
    if (employeeInitRequest?.status === "Draft") {
      return (
        <button
          onClick={() => {
            const type = employeeInitRequest?.request_type;
            if (type === "Leave Application Form") handleSaveLeaveApplicationFrom("");
            else if (type === "Tardiness Application Form") handleSaveTardinessApplicationFrom("");
            else if (type === "Change Shift Application Form") handleSaveChangeShifApplicationFrom("");
            else handleSaveChangeDOApplicationFrom("");
          }}
          className="w-full mt-6 flex items-center justify-center bg-blue-500 text-white text-lg py-2 rounded-lg outline-none focus:border-none"
        >
          {loadingSubmitEmployeeInitRequest ? <Loader className="animate-spin" /> : "Submit"}
        </button>
      );
    } else if (employeeInitRequest?.status === "Pending") {
      return (
        <>
          {employeeInitRequest?.allow_accept === "Yes" && (
            <>
              <button
                onClick={() => {
                  setisDailogAddRemark(true);
                  setStatus("Rejected");
                }}
                className="w-full mt-6 flex items-center justify-center bg-red-500 text-white text-lg py-2 rounded-lg outline-none focus:border-none"
              >
                Reject
              </button>
              <button
                onClick={() => {
                  setisDailogAddRemark(true);
                  setStatus("Approved");
                }}
                className="w-full mt-6 flex items-center justify-center bg-green-500 text-white text-lg py-2 rounded-lg outline-none focus:border-none"
              >
                Approve
              </button>
            </>
          )}

          {employeeInitRequest?.allow_cancel === "Yes" && (
            <button
              onClick={() => {
                setisDailogAddRemark(true);
                setStatus("Cancelled");
              }}
              className="w-full mt-6 flex items-center justify-center bg-red-500 text-white text-lg py-2 rounded-lg"
            >
              Cancel
            </button>
          )}
        </>
      );
    } else if (employeeInitRequest?.status === "Cancelled") {
      return (
        <>
          {employeeInitRequest?.allow_delete === "Yes" && (
            <button
              onClick={() =>
                showDialogConfirm({
                  titileButtonSubmit: "Yes, Delete",
                  titileButtonCancel: "No, Cancel",
                  title: "Delete",
                  message: "Do you want to delete ?",
                  onSubmit() {
                    submitShopEmployeeRequestUpdateStatus(employeeInitRequest?.id, "Deleted", "");
                    setOpenPopoverIndex(null);
                  },
                })
              }
              className="w-full mt-6 flex items-center justify-center bg-red-500 text-white text-lg py-2 rounded-lg outline-none focus:border-none"
            >
              Delete
            </button>
          )}
          {employeeInitRequest?.allow_submit === "Yes" && (
            <button
              onClick={() => {
                const type = employeeInitRequest?.request_type;
                if (type === "Leave Application Form") handleSaveLeaveApplicationFrom("");
                else if (type === "Tardiness Application Form") handleSaveTardinessApplicationFrom("");
                else if (type === "Change Shift Application Form") handleSaveChangeShifApplicationFrom("");
                else handleSaveChangeDOApplicationFrom("");
              }}
              className="w-full mt-6 flex items-center justify-center bg-blue-500 text-white text-lg py-2 rounded-lg outline-none focus:border-none"
            >
              {loadingSubmitEmployeeInitRequest ? <Loader className="animate-spin" /> : "Resubmit"}
            </button>
          )}
        </>
      );
    } else if (employeeInitRequest?.status === "Rejected") {
      return (
        <>
          {employeeInitRequest?.allow_delete === "Yes" && (
            <button
              onClick={() =>
                showDialogConfirm({
                  titileButtonSubmit: "Yes, Delete",
                  titileButtonCancel: "No, Cancel",
                  title: "Delete",
                  message: "Do you want to delete ?",
                  onSubmit() {
                    submitShopEmployeeRequestUpdateStatus(employeeInitRequest?.id, "Deleted", "");
                    setOpenPopoverIndex(null);
                  },
                })
              }
              className="w-full mt-6 flex items-center justify-center bg-red-500 text-white text-lg py-2 rounded-lg outline-none focus:border-none"
            >
              Delete
            </button>
          )}
          {employeeInitRequest?.allow_submit === "Yes" && (
            <button
              onClick={() => {
                const type = employeeInitRequest?.request_type;
                if (type === "Leave Application Form") handleSaveLeaveApplicationFrom("");
                else if (type === "Tardiness Application Form") handleSaveTardinessApplicationFrom("");
                else if (type === "Change Shift Application Form") handleSaveChangeShifApplicationFrom("");
                else handleSaveChangeDOApplicationFrom("");
              }}
              className="w-full mt-6 flex items-center justify-center bg-blue-500 text-white text-lg py-2 rounded-lg outline-none focus:border-none"
            >
              {loadingSubmitEmployeeInitRequest ? <Loader className="animate-spin" /> : "Resubmit"}
            </button>
          )}
        </>
      );
    } else if (employeeInitRequest?.status === "Approved") {
      return (
        <>
          <button
            onClick={() => {
              setisDailogAddRemark(true);
              setStatus("Cancelled");
            }}
            className="w-full mt-6 flex items-center justify-center bg-red-500 text-white text-lg py-2 rounded-lg outline-none focus:border-none"
          >
            Cancel
          </button>
        </>
      );
    } else {
      return <></>;
    }
  };
  // *================Variable===========
  const dataEmployeeRequest = useRequestAction();
  const [valuesRemarkLeave, setValuesRemarkLeave] = useState("");
  const [valuesRemarkTardiness, setValuesRemarkTardiness] = useState("");
  const [valuesRemarkChangeDo, setValuesRemarkChangeDo] = useState("");
  const [valuesRemarkChangeShift, setValuesRemarkChangeShift] = useState("");
  const [valuesWhyMissing, setValuesWhyMissing] = useState("");
  const [selectedCodes, setSelectedCodes] = useState<string>("");
  const [entitlements, setEntitlements] = useState<any[]>([]);
  const monthDate = moment(leaveApplicationFrom.starting_date).format("yyyy");
  const [isRemovingApprover, setIsRemovingApprover] = useState<boolean>(false);
  const [isOpenDialogApporver, setIsOpenDialogApporver] = useState<boolean>(false);
  const [isOpenDialogWorkflow, setIsOpenDialogWorkflow] = useState<boolean>(false);
  const [isDailogAddRemark, setisDailogAddRemark] = useState<boolean>(false);
  const [status, setStatus] = useState<any>("");
  // *================Ueffect===========
  useEffect(() => {
    if (employeeInitRequest?.document) {
      setLeaveApplicationFrom((prev: any) => ({
        ...prev,
        starting_date: employeeInitRequest?.document.starting_date || "",
        ending_date: employeeInitRequest?.document.ending_date || "",
        no_of_day: employeeInitRequest?.document.no_of_day || "",
        leave_period: employeeInitRequest?.document.leave_period || "",
        leave_type: employeeInitRequest?.document.leave_type || "",
        starting_time: employeeInitRequest?.document.starting_time || "",
        ending_time: employeeInitRequest?.document.ending_time || "",
        reason: employeeInitRequest?.document.reason || valuesRemarkLeave,
      }));
      // ----------------
      const periodString = employeeInitRequest.document.missing_period || "";
      const defaultSelected = periodString
        .split("|")
        .map((item: any) => item.trim())
        .filter(Boolean)
        .join(" | "); // ✅ Join back to string
      setSelectedCodes(defaultSelected); // ✅ now it's a string, no error
      setTardinessApplicationFrom((prev: any) => ({
        ...prev,
        working_date: employeeInitRequest.document.working_date || "",
        missing_period: periodString,
        missing_type: employeeInitRequest.document.missing_type || valuesWhyMissing,
        missing_remark: employeeInitRequest.document.missing_remark || valuesRemarkTardiness,
      }));
      // --------------
      setChangeDoApplicationFrom((prev: any) => ({
        ...prev,
        working_date: employeeInitRequest.document.working_date || "",
        remark: employeeInitRequest.document.remark || valuesRemarkChangeDo,
      }));
      // -------------
      setChangeShiftApplication((prev: any) => ({
        ...prev,
        to_shift_group_id: employeeInitRequest.document?.to_shift_group?.shift_group_id ?? "",
        working_date: employeeInitRequest.document.working_date || "",
        remark: employeeInitRequest.document.remark || valuesRemarkChangeShift,
        to_shift_group: employeeInitRequest.document?.to_shift_group || "",
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeInitRequest]);

  useEffect(() => {
    if (leaveApplicationFrom.starting_date && leaveApplicationFrom.no_of_day) {
      const endingDate = moment(leaveApplicationFrom.starting_date)
        .add(leaveApplicationFrom.no_of_day - 1, "days")
        .format("YYYY-MM-DD");
      setLeaveApplicationFrom((prev: any) => ({
        ...prev,
        ending_date: endingDate,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leaveApplicationFrom.starting_date, leaveApplicationFrom.no_of_day]);

  useEffect(() => {
    const monthDate = moment(leaveApplicationFrom.starting_date).format("yyyy"); // or "YYYY"
    const dataToFilter = Array.isArray(employeeInitRequest?.document?.entitlements) ? employeeInitRequest.document.entitlements : [];
    const result = dataToFilter.filter((item: any) => item.entitlement_year?.toString().includes(monthDate));
    setEntitlements(result);
  }, [leaveApplicationFrom.starting_date, employeeInitRequest]);

  return (
    <div className="custom-dialog-class flex flex-col justify-between  h-[calc(100vh-80px)]">
      {/* Header */}
      <div>
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-2 absolute left-3 top-[12px]">
            <div className="text-lg font-bold">{employeeInitRequest?.request_type}</div>
            <div>
              {employeeInitRequest?.request_type === "Leave Application Form" && "Please fill out the details of your leave request."}
              {employeeInitRequest?.request_type === "Tardinees Application Form" && "Fill out this form to document your late attendance."}
              {employeeInitRequest?.request_type === "Change DO Application Form" && "Submit your request to modify your regular day off schedule."}
              {employeeInitRequest?.request_type === "Change Shift Application Form" && "Request to modify assigned work shift schedule."}
            </div>
          </div>
          {employeeInitRequest && (
            <div
              className={`absolute flex items-center py-1 text-white px-5 justify-center font-bold 
                  ${DocumentStatus.getColorByStr(employeeInitRequest?.status)}
                rounded-md right-[60px] top-[16px] z-40    `}
            >
              {employeeInitRequest?.status}
            </div>
          )}
          <div
            className="absolute flex items-center justify-center right-3 top-[12px] z-40 cursor-pointer rounded-full bg-accent hover:text-accent-foreground w-10 h-10 border border-gray-300"
            onClick={() => handleCloseDetail()}
          >
            <X />
          </div>
        </div>
      </div>
      {warning ? (
        <Status errorStatus={errorStatus} className="h-full" />
      ) : (
        <>
          {warning2 ? (
            <Status errorStatus={errorStatus} className="h-full" />
          ) : (
            <>
              {loadingEmployeeInitRequestSearchDatail || loadingEmployeeInitRequest ? (
                <div className="h-[70vh] mt-8 overflow-hidden">
                  <ShimmerDialogEditProduct />
                </div>
              ) : (
                <ScrollArea className="mt-8 gap-3 pr-[10px] pb-[50px] h-full">
                  <div className="space-y-6 px-1 py-1">
                    {/* ------requester----- */}

                    <Requester employeeInitRequest={employeeInitRequest} />

                    {/* -----------Leave Application Form------- */}
                    {employeeInitRequest?.request_type === "Leave Application Form" && (
                      <>
                        <RequestleaveApplicationForm
                          monthDate={monthDate}
                          entitlements={entitlements}
                          employeeInitRequest={employeeInitRequest}
                          handleChangeLeaveRequest={handleChangeLeaveRequest}
                          leaveApplicationFrom={leaveApplicationFrom}
                          setValuesRemarkLeave={setValuesRemarkLeave}
                        />
                      </>
                    )}
                    {/* -----------Tardiness Application Form------- */}

                    {employeeInitRequest?.request_type === "Tardiness Application Form" && (
                      <>
                        <TardinessApplicationForm
                          selectedCodes={selectedCodes}
                          handleClick={handleClick}
                          employeeInitRequest={employeeInitRequest}
                          handleChangeTardinessRequest={handleChangeTardinessRequest}
                          tardinessApplicationFrom={tardinessApplicationFrom}
                          setValuesRemarkTardiness={setValuesRemarkTardiness}
                          setValuesWhyMissing={setValuesWhyMissing}
                        />
                      </>
                    )}
                    {/* -----------Change DO Application Form------- */}

                    {employeeInitRequest?.request_type === "Change DO Application Form" && (
                      <>
                        <ChangeDOApplicationForm
                          employeeInitRequest={employeeInitRequest}
                          handleChangeDoRequest={handleChangeDoRequest}
                          changeDoApplicationFrom={changeDoApplicationFrom}
                          setValuesRemarkChangeDo={setValuesRemarkChangeDo}
                        />
                      </>
                    )}
                    {/* -----------Change Shift Application Form------- */}

                    {employeeInitRequest?.request_type === "Change Shift Application Form" && (
                      <>
                        <ChangeShiftApplicationForm
                          employeeInitRequest={employeeInitRequest}
                          handleChangeShiftRequest={handleChangeShiftRequest}
                          changeShiftApplication={changeShiftApplication}
                          setChangeShiftApplication={setChangeShiftApplication}
                          setValuesRemarkChangeShift={setValuesRemarkChangeShift}
                        />
                      </>
                    )}

                    <AddApproverRequest
                      employeeInitRequest={employeeInitRequest}
                      isRemovingApprover={isRemovingApprover}
                      setIsRemovingApprover={setIsRemovingApprover}
                      setEmployeeInitRequest={setEmployeeInitRequest}
                      setIsOpenDialogApporver={setIsOpenDialogApporver}
                      getShopEmployeeRequestCommittee={getShopEmployeeRequestCommittee}
                    />
                  </div>

                  <ScrollBar orientation="vertical" />
                </ScrollArea>
              )}

              <div className="flex justify-between gap-3 pr-[20px] items-center px-4 left-0 w-full">{renderButtonSubmit()}</div>
            </>
          )}
        </>
      )}
      <DailogAddRemark
        submitShopEmployeeRequestUpdateStatus={submitShopEmployeeRequestUpdateStatus}
        setOpenPopoverIndex={setOpenPopoverIndex}
        employeeInitRequest={employeeInitRequest}
        isDailogAddRemark={isDailogAddRemark}
        setisDailogAddRemark={setisDailogAddRemark}
        status={status}
        submitShopEmployeeRequestUpdateStatusLoading={submitShopEmployeeRequestUpdateStatusLoading}
      />
      <DailogAddApprovers
        scrollContainerRef={scrollContainerRef}
        isOpenDialogApporver={isOpenDialogApporver}
        setIsOpenDialogApporver={setIsOpenDialogApporver}
        shopEmployeeRequestCommittee={shopEmployeeRequestCommittee}
        handleAddApprover={handleAddApprover}
        handleScrollCommittee={handleScrollCommittee}
        fetchMoreDataCommittee={fetchMoreDataCommittee}
        getShopEmployeeRequestCommittee={getShopEmployeeRequestCommittee}
        isAddApproverLoading={isAddApproverLoading}
        setShopEmployeeRequestCommittee={setShopEmployeeRequestCommittee}
        employeeInitRequest={employeeInitRequest}
      />
      <DailogAddWorkflow isOpenDialogWorkflow={isOpenDialogWorkflow} setIsOpenDialogWorkflow={setIsOpenDialogWorkflow} />
    </div>
  );
}
